import React from 'react';
import {
	NavLink,
	Link
} from 'react-router-dom'


import l1 from './../../../assets/img/projects/list/l1.jpg';
import l2 from './../../../assets/img/projects/list/l2.jpg';
import l3 from './../../../assets/img/projects/list/l3.jpg';
import l4 from './../../../assets/img/projects/list/l4.jpg';

class RelatedProjects extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {
        return (
            <section className="mole__project-grid mole__related-projects mb-0">
                    <div className="main-container">
                        <div className="inner-container">
                            <h5 className="font-lg-head c-general --title">Related Projects</h5>

                            <div className="inner-grid">
                                <figure className="fig-l c-community">
                                    <Link className="link project-link" exact to={`${process.env.PUBLIC_URL}/project/details`}></Link>

                                    <figcaption>
                                        <p>Project Title</p>
                                        <p>An ode to Ely Cathedral lorem ipsum dolor lorem ipsum</p>
                                    </figcaption>

                                    <img src={l1} alt="ProjctTitle" title="ProjctTitle"/>
                                    <img src={l3} alt="ProjctTitle" title="ProjctTitle"/>
                                </figure>

                                
                                <figure className="fig-l c-workplace">
                                    <Link className="link project-link" exact to={`${process.env.PUBLIC_URL}/project/details`}></Link>

                                    <figcaption>
                                        <p>Project Title</p>
                                        <p>An ode to Ely Cathedral lorem ipsum dolor lorem ipsum</p>
                                    </figcaption>

                                    <img src={l2} alt="ProjctTitle" title="ProjctTitle"/>
                                    <img src={l4} alt="ProjctTitle" title="ProjctTitle"/>
                                </figure>
                            </div>
                        </div>
                    </div>
                </section>
        );
    }
}
export default RelatedProjects;



// WEBPACK FOOTER //
// ./src/components/Projects/Details/RelatedProjects.js